const defaultTheme = {
  "--primary": "243 75% 59%",
  "--border": "214.3, 31.8%, 91.4%",
  "--border-opacity": "0.5",
  "--radius": "0.5rem",
};

const caminoTheme = {
  ...defaultTheme,
  "--background": "43.04deg 35.19% 89.41%",
  "--foreground": "172.8deg 21.74% 22.55%",
  "--muted": "43.04deg 32.16% 85.49%",
  "--primary": "172.8deg 21.74% 22.55%",
  "--primary-foreground": "0deg 0% 100%",
  "--border": "172.8deg, 21.74%, 22.55%",
  "--border-opacity": "0.2",
};

const hookedTheme = {
  ...defaultTheme,
  "--primary": "217 60.9% 17.1%",
  "--background": "34, 89%, 96%",
  "--primary-foreground": "34, 89%, 96%",
};

const warpigsTheme = {
  ...defaultTheme,
  "--primary": "0 0% 20.2%",
  "--background": "0 0% 90%",
  "--border": "0,0%,20.2%",
  "--muted-foreground": "0,0%,30.2%",
  "--border-opacity": "0.2",
  "--radius": "0.25rem",
};

const mikkellerAndFriendsTheme = {
  ...defaultTheme,
  "--primary": "217.82deg 100% 32.35%",
};

const rtbTheme = {
  ...defaultTheme,
  "--primary": "355.41deg 71.43% 46.67%",
  "--foreground": "0deg 0% 97.25%",
  "--muted-foreground": "0deg 0% 97.25% / 80%",
  "--muted": "0deg 0% 97.25% / 10%",
  "--border": "0deg, 0%, 97.25%",
  "--border-opacity": "0.25",
  "--background": "0deg 0% 10%",
};

const faergekroenTheme = {
  ...defaultTheme,
  "--primary": "226.19deg 100% 22.16%",
  "--foreground": "226.19deg 100% 22.16%",
  "--background": "56 40% 92%",
  "--border": "226.19deg, 100%, 30%",
  "--border-opacity": "0.25",
  "--divider": "226.19deg 100% 30% / 25%",
  "--muted": "56 40% 96%",
  "--muted-foreground": "226.19deg 100% 22.16%",
};

const frihedenTheme = {
  ...defaultTheme,
  "--primary": "230.87deg 54.12% 33.33%",
};

const psBarCityTheme = {
  ...defaultTheme,
  "--primary": "147.56deg 100% 33.73%",
  "--background": "46.15deg 100% 97.45%",
  "--muted": "147.56deg 100% 33.73% / 9%",
};

const motherCityTheme = {
  ...defaultTheme,
  "--primary": "0deg 0% 0%", // "21.55deg 89.43% 48.24%",
};

const seasideTheme = {
  ...defaultTheme,
  "--background": "35deg 50% 95.29%",
  "--foreground": "200.57deg 28% 24.51%",
  "--primary": "37.66deg 52.81% 65.1%",
  "--primary-foreground": "200.57deg 28% 24.51%",
  "--muted": "200.57deg 28% 99.51%",
};

const mikkellerBaghavenTheme = {
  ...defaultTheme,
  "--primary": "33.67deg 54.94% 50.39%",
  "--background": "0deg 0% 95.29%",
  "--muted": "0 0% 90%",
};

const bootleggersTheme = {
  ...defaultTheme,
  "--primary": "0 0% 20.2%",
};

const cocksAndCowsTheme = {
  ...defaultTheme,
  "--primary": "48.15deg 97.52% 68.43%",
  "--primary-foreground": "0 0% 20.2%",
  "--foreground": "48.15deg 97.52% 68.43%",
  "--background": "151.15deg 53.06% 19.22%",
  "--muted": "48.15deg 97.52% 68.43%",
  "--muted-foreground": "151.15deg 53.06% 19.22%",
};

const copenhellTheme = {
  ...defaultTheme,
  "--primary": "0deg 0% 100%",
  "--primary-foreground": "0deg 0% 0% / 100%",
  "--foreground": "0deg 0% 100%",
  "--muted-foreground": "0deg 0% 100% / 80%",
  "--muted": "0deg 0% 13%",
  "--border": "0deg, 0%, 100%",
  "--border-opacity": "0.05",
  "--background": "0deg 0% 5%",
};

type Theme = Record<string, string>;

export {
  defaultTheme,
  warpigsTheme,
  faergekroenTheme,
  mikkellerAndFriendsTheme,
  caminoTheme,
  rtbTheme,
  hookedTheme,
  frihedenTheme,
  psBarCityTheme,
  motherCityTheme,
  seasideTheme,
  mikkellerBaghavenTheme,
  bootleggersTheme,
  cocksAndCowsTheme,
  copenhellTheme,
};
export type { Theme };
